// Data Dashboard Main Page Component
export default {
  // Beginner Guide
  finishButton: "Finish",

  // Search Box
  searchPlaceholder: "Please enter the case you want to search",
  searchButton: "Search",

  // Messages
  dataLoading:
    "Case data is being fetched, it may take one day. Please wait patiently!",
  noSearchResult: "No results found for your search!",
  noData: "N/A",
};
